var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#F1F8E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.58857 14.1464C9.61607 14.3461 9.78977 14.5 9.99994 14.5C10.2292 14.5 10.4151 14.3168 10.4151 14.0909L10.4151 6.90003L13.0407 9.49765L13.0872 9.53736C13.2494 9.65652 13.4801 9.64379 13.6278 9.49885C13.7903 9.33942 13.7908 9.0804 13.629 8.92031L10.2998 5.62613C10.2807 5.60651 10.2597 5.58876 10.237 5.57319C10.0749 5.46169 9.84996 5.4774 9.70553 5.62033L6.37097 8.92033L6.33087 8.9663C6.21063 9.12671 6.22452 9.35395 6.37223 9.49887C6.53471 9.65829 6.79757 9.65773 6.95935 9.49763L9.58478 6.89939L9.58478 14.0909L9.58857 14.1464Z",
    fill: "#8DC63F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpIcon);
export default __webpack_public_path__ + "static/media/up_icon.1fb7f306b7e6df496433be5ce4323768.svg";
export { ForwardRef as ReactComponent };